import { Component, Input } from '@angular/core';
import { ChecksComponent } from '../../../../../processes/components/checks/checks.component';
import { CHECK, IProcessDetailResponse } from '../../../../../processes/models/processes.models';

/**
 * Comprobación de cotejo FORM (`match_ocr` / `match_data`) en tile «Contraste de información».
 */
@Component({
	selector: 'app-operation-form-checks-compare-info',
	imports: [ChecksComponent],
	templateUrl: './operation-form-checks-compare-info.component.html',
})
export class OperationFormChecksCompareInfoComponent {
	@Input({ required: true }) checksDetail!: IProcessDetailResponse;

	protected readonly checks: CHECK[] = [CHECK.FORM_MATCH_DATA];
}
